import { Injectable } from '@angular/core';

import { Location } from '@shared/location/models';
import { LocationRecurly } from '@shared/restaurant/models';
import { SubscriptionTypes } from '@shared/restaurant/enums';
import { SubscriptionState } from '@shared/recurly/enums';

@Injectable({ providedIn: 'root' })
export class PricePlansRestrictionsService {
  availableForStarterPlan(subscriptionType: SubscriptionTypes, recurlyData: LocationRecurly): boolean {
    if (subscriptionType === SubscriptionTypes.offline) {
      return true;
    }

    if (recurlyData.subscription_state === SubscriptionState.paused) {
      return false;
    }

    const { planCode } = recurlyData;
    if (!planCode) {
      return false;
    }

    return planCode.includes('starter') ||
      planCode.includes('basic') ||
      planCode.includes('reef') ||
      planCode.includes('standard') ||
      planCode.includes('business') ||
      planCode.includes('premium');
  }

  availableForBusinessPlan(subscriptionType: SubscriptionTypes, recurlyData: LocationRecurly): boolean {
    if (subscriptionType === SubscriptionTypes.offline) {
      return true;
    }

    if (recurlyData.subscription_state === SubscriptionState.paused) {
      return false;
    }

    const { planCode } = recurlyData;
    if (!planCode) {
      return false;
    }

    return planCode.includes('standard') ||
      planCode.includes('reef') ||
      planCode.includes('business') ||
      planCode.includes('premium');
  }

  getTierRank(subscriptionType: SubscriptionTypes | undefined, recurly: LocationRecurly | undefined): number {
    if (!subscriptionType || !recurly) {
      return 0;
    }
    if (this.availableForBusinessPlan(subscriptionType, recurly)) {
      return 2;
    }
    if (this.availableForStarterPlan(subscriptionType, recurly)) {
      return 1;
    }
    return 0;
  }

  accountHasLocationWithBusinessPlan(subscriptionType: SubscriptionTypes, locations: Location[]): boolean {
    let hasBusinessPlanLocation = false;

    for (const loc of locations) {
      const availableForBusinessPlan = this.availableForBusinessPlan(subscriptionType, loc.recurly);

      if (availableForBusinessPlan) {
        hasBusinessPlanLocation = true;
        break;
      }
    }

    return hasBusinessPlanLocation;
  }
}
